
import "@rmwc/icon-button/styles";
import "@rmwc/rc-tooltip/styles";
import { TextField } from "@rmwc/textfield";
import PropTypes from "prop-types";

// #region FONCTION COMPOSANT
/**
 * Composant permettant d'afficher la quantité restante
 * @category Distribution
 * @param {DistributionQuantite.propTypes} props Les propriétés du composant
 */
function DistributionQuantite(props) {
  //#region INITIALISATION
  // Récupération des props
  const {
    detailAchat,
  } = props;
  // #endregion

  //#region INTERFACE
  // Interface
  // Si pas de détail achat, pas de rendu
  if (!detailAchat) {
    return null;
  }

  return (

    <div className="TimeSelector-Container">
      <TextField
        className="TimeSelector-TextField"
        disabled
        style={{ width: "5rem" }}
        value={detailAchat.quantiteRestante}
      />
      <div>{detailAchat.libelleType}</div>
    </div>

    // <div className="DistributionQuantite-Container">
    //   <RCTooltip content="Durée restante">
    //     <IconButton icon="alarm" />
    //   </RCTooltip>
    // </div>

  );
  // #endregion
};
// #endregion

// #region PROPRIETES
/**
 * Type des propriétés de {@link DistributionQuantite}
 * @typedef {Object} DistributionQuantite.propTypes
 * @property {object} detailAchat Le détail de l'achat
 */
DistributionQuantite.propTypes = {
  detailAchat: PropTypes.object.isRequired
};
// #endregion

export { DistributionQuantite };

